import type { FC, HTMLAttributes, ReactNode, RefObject } from "react";
import { CARD_THEME as _ct } from "./Card.constants";

export interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: "small" | "medium";
  ref?: RefObject<HTMLElement | null>;
}

const Card: FC<CardProps & HTMLAttributes<HTMLElement>> = ({
  children,
  padding = "small",
  className = "",
  ...props
}) => {
  return (
    <section
      className={`group/card p-${_ct.padding[padding]} ${_ct.radius} relative bg-background-paper border ${_ct.borderColor} overflow-hidden @container ${className}`}
      {...props}
    >
      {children}
    </section>
  );
};

export default Card;
